import { action } from 'satcheljs';

import type { SonoraDataProviderConfig, SonoraViewState } from 'owa-editor-sonora-types';

export const fetchSuggestions = action(
    'fetchSuggestions',
    (
        viewState: SonoraViewState,
        config: SonoraDataProviderConfig,
        loadTimeDp: string,
        updateDp: string,
        callInitOps: boolean = false
    ) => ({
        viewState: viewState,
        callInitOps: callInitOps,
        loadTimeDp: loadTimeDp,
        updateDp: updateDp,
        config: config,
    })
);
